import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss'],
})
export class DisclaimerComponent implements OnInit {
  @Input() text: string = '';
  constructor() {}

  ngOnInit(): void {}
}
